'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
function $ct_Lpresto_LoginPageView$Mode__Lpresto_LoginPageView__($thiz, outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  return $thiz;
}
export { $ct_Lpresto_LoginPageView$Mode__Lpresto_LoginPageView__ as $ct_Lpresto_LoginPageView$Mode__Lpresto_LoginPageView__ };
/** @constructor */
function $c_Lpresto_LoginPageView$Mode() {
}
export { $c_Lpresto_LoginPageView$Mode as $c_Lpresto_LoginPageView$Mode };
$p = $c_Lpresto_LoginPageView$Mode.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$Mode;
/** @constructor */
function $h_Lpresto_LoginPageView$Mode() {
}
export { $h_Lpresto_LoginPageView$Mode as $h_Lpresto_LoginPageView$Mode };
$h_Lpresto_LoginPageView$Mode.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=presto.-Login-Page-View$-Mode.js.map
